import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ae{box-shadow:0px 0px 15px 0px rgba(0, 0, 0, 0.15);}.ssr-plugin'
import '.af{border-radius:1.25rem;}.ssr-plugin'
import '.ag{background-color:var(--shades-white);}.ssr-plugin'
import '.q{overflow:hidden;}.ssr-plugin'
import '.dt{padding:1rem 1.5rem;}.ssr-plugin'
import '.d4{background:var(--shades-white);}.ssr-plugin'
import '.v{justify-content:space-between;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.du{align-self:center;}.ssr-plugin'
import '.c0{padding:1.5rem;}.ssr-plugin'
import '.f{gap:1.5rem;}.ssr-plugin'
import '.k{display:grid;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.u{width:100%;}.ssr-plugin'
import '.dv{gap:0.75rem;}.ssr-plugin'
import '.bp{padding:1rem;}.ssr-plugin'
import '.c3{background-color:var(--shades-blue-50);}.ssr-plugin'
import '.b3{border:none;}.ssr-plugin'
import '.dw{border-radius:1rem;}.ssr-plugin'
import '.ar{cursor:pointer;}.ssr-plugin'
import '.dx{transition:background-color 0.2s ease;}.ssr-plugin'
import '.d1{width:1rem;}.ssr-plugin'
import '.d2{height:1rem;}.ssr-plugin'
import '.b8{color:var(--primary-blue);}.ssr-plugin'
import '.dy{font-size:1.15rem;}.ssr-plugin'
import '.ba{font-weight:400;}.ssr-plugin'
import '.dz{justify-content:flex-end;}.ssr-plugin'
import { styled } from 'inlines'
import { useState } from 'react'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { Title } from '@app/components/core/typography/Title'
import useMediaQuery from '@app/util/useMediaQuery'
import { useTranslations } from '@i18n/useLanguage'
import { ModalWrapper } from './ModalWrapper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faLink } from '@fortawesome/pro-regular-svg-icons'
import { faXTwitter, faFacebook, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { SocialMediaButton } from './SocialMediaButton'

export type SocialShareModalProps = {
  isOpen: boolean
  onClose: () => void
  url?: string
  title?: string
  renderContainer?: HTMLElement
}

export const SocialShareModal = ({
  isOpen,
  onClose,
  url: urlProp,
  title: titleProp,
  renderContainer,
}: SocialShareModalProps) => {
  const translations = useTranslations().app.socialShareModal
  const isMobile = useMediaQuery()
  const [copySuccess, setCopySuccess] = useState(false)

  const url =
    urlProp ?? (typeof window !== 'undefined' ? window.location.href : '')
  const title =
    titleProp ?? (typeof document !== 'undefined' ? document.title : '')

  const handleClose = () => {
    setCopySuccess(false)
    onClose()
  }

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        setCopySuccess(true)
        setTimeout(() => setCopySuccess(false), 2000)
      })
      .catch((err) => {
        console.error('Failed to copy link:', err)
      })
  }

  const handleEmailShare = () => {
    const subject = encodeURIComponent(`Check out: ${title}`)
    const body = encodeURIComponent(
      `I thought you might be interested in this: ${url}`,
    )
    window.open(`mailto:?subject=${subject}&body=${body}`)
  }

  const handleXShare = () => {
    const text = encodeURIComponent(`Check out: ${title}`)
    window.open(
      `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(url)}`,
    )
  }

  const handleFacebookShare = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    )
  }

  const handleWhatsAppShare = () => {
    const text = encodeURIComponent(`Check out: ${title} - ${url}`)
    window.open(`https://wa.me/?text=${text}`)
  }

  if (!isOpen) {
    return null
  }

  const content = (
    <div className="a b ae af ag q"
      data-testid="social-share-modal"
      style={{
        maxWidth: isMobile ? '90vw' : '29.5rem',
      }}
    >
      {/* Header */}
      <div className="a dt d4 v c"
      >
        <Title.H5 style={{ margin: 0 }}>
          {translations.title}
        </Title.H5>
        <CloseButton onClick={handleClose} size="small" />
      </div>

      {/* Content */}
      <div className="a du b c0 d4 f"
      >

        {/* Social Media Buttons */}
        <div className="k f" 
          style={{
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',}}
        >
          <SocialMediaButton icon={faEnvelope} label={translations.email} onClick={handleEmailShare} isMobile={isMobile} />
          <SocialMediaButton icon={faXTwitter} label={translations.x} onClick={handleXShare} isMobile={isMobile} />
          <SocialMediaButton icon={faFacebook} label={translations.facebook} onClick={handleFacebookShare} isMobile={isMobile} />
          <SocialMediaButton icon={faWhatsapp} label={translations.whatsapp} onClick={handleWhatsAppShare} isMobile={isMobile} />
        </div>

        {/* Copy Link Button */}
        <styled.button className="a c g u dv bp c3 b3 dw ar dx"
          onClick={handleCopyLink}
          style={{
            '&:hover': {
              backgroundColor: 'var(--shades-blue-100)',
            },
          }}
        >
          <div className="d1 d2 a c g b8"
          >
            <FontAwesomeIcon icon={faLink} />
          </div>
          <span className="dy b8 ba"
          >
            {copySuccess ? translations.copiedLink : translations.copyLink}
          </span>
        </styled.button>
      </div>

      {/* Footer */}
      <div className="a dt d4 dz c"
      >
        <Button
          label={translations.close}
          onClick={handleClose}
          variant="primary"
          size="medium"
          style={{
            backgroundColor: 'var(--primary-red)',
            borderColor: 'var(--primary-red)',
          }}
        />
      </div>
    </div>
  )

  return (
    <ModalWrapper renderContainer={renderContainer}>{content}</ModalWrapper>
  )
}
